import LoginFormV2 from "./LoginFormV2";
export default LoginFormV2;
